<template>
    <div class="svg-container-outer">
        <LoadingData v-if="loadingDespatch" :headerMessage="'Loading Optimization'"/>
        <div class="route-info">
            <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)" class="route-info-inner">
                <h3 class="manifest-header">Dispatched Manifest</h3>
                <h3 class="manifest-header">Trip Sheet: {{selectedTripSheetID}}</h3>
                <h3 class="manifest-header">Route: {{manifestMapData[0]?.route}}</h3>
                <h3 class="manifest-header">
                    Driver:
                    {{
                        selectedTripSheetObject?.driverCode ||
                        "Not Assigned"
                    }}
                </h3>

                <button
                    class="update-driver-button"
                    @click="openDriverPopup"
                >
                    {{
                        selectedTripSheetObject?.driverCode
                            ? "Update Driver"
                            : "Assign Driver"
                    }}
                </button>
                <button 
                class="update-trip-button abandon-trip-button"
                @click="showAbandonTripPopup = true">Abandon Trip</button>
            </div>
        </div>

        <div
            v-if="showAbandonTripPopup"
            class="popup-overlay"
            @click.self="closeAbandonTripPopup"
        >
            <div class="abandon-trip-popup">
                <h2>Abandon Trip</h2>

                <p>
                    Are you sure you want to abandon this trip?
                </p>

                <div class="abandon-trip-details">
                    <p>
                        <strong>Trip Sheet:</strong>
                        {{ selectedTripSheetID }}
                    </p>

                    <p>
                        <strong>Route:</strong>
                        {{ manifestMapData[0]?.route || "Not Available" }}
                    </p>

                    <p>
                        <strong>Driver:</strong>
                        {{
                            selectedTripSheetObject?.driverCode ||
                            "Not Assigned"
                        }}
                    </p>
                </div>

                <div class="popup-button-container">
                    <button
                        class="cancel-button"
                        :disabled="abandoningTrip"
                        @click="closeAbandonTripPopup"
                    >
                        Cancel
                    </button>

                    <button
                        class="confirm-abandon-button"
                        :disabled="abandoningTrip"
                        @click="confirmAbandonTrip"
                    >
                        {{
                            abandoningTrip
                                ? "Abandoning..."
                                : "Confirm Abandon"
                        }}
                    </button>
                </div>
            </div>
        </div>

        <div
            v-if="toggleDriverPopup"
            class="driver-popup-overlay"
        >
            <div class="driver-popup">
                <div class="driver-popup-header">
                    <h2>
                        {{
                            selectedTripSheetObject?.driverCode
                                ? "Update Trip Sheet Driver"
                                : "Assign Trip Sheet Driver"
                        }}
                    </h2>

                    <button
                        class="close-driver-popup"
                        @click="closeDriverPopup"
                    >
                        ×
                    </button>
                </div>

                <div class="driver-popup-details">
                    <div class="driver-detail-row">
                        <strong>Trip Sheet ID:</strong>

                        <span>
                            {{ selectedTripSheetID }}
                        </span>
                    </div>

                    <div class="driver-detail-row">
                        <strong>Route:</strong>

                        <span>
                            {{
                                selectedTripSheetObject?.routeCode ||
                                manifestMapData[0]?.route ||
                                "None"
                            }}
                        </span>
                    </div>

                    <div class="driver-detail-row">
                        <strong>Current Driver:</strong>

                        <span>
                            {{
                                selectedTripSheetObject?.driverCode ||
                                "Not Assigned"
                            }}
                        </span>
                    </div>

                    <div class="driver-detail-row">
                        <strong>New Driver:</strong>

                        <span>
                            {{
                                selectedDriver ||
                                "No driver selected"
                            }}
                        </span>
                    </div>
                </div>

                <div class="driver-search-container">
                    <driver-table @checkBoxSelectID="checkBoxDriverCode($event)" :key="refreshKey" :jwtToken="jwtToken" :userData="userData"/>
                    <!--
                        Paste your searchable driver table here.

                        When a driver is selected, assign the full
                        driver object to:

                        this.selectedDriver

                        Example:

                        @driverSelected="selectDriver($event)"
                    -->
                </div>

                <div class="driver-popup-buttons">
                    <button
                        class="cancel-driver-button remove-driver-button"
                        :disabled="
                            updatingTripSheetDriver
                        "
                        @click="removeTripSheetDriver"
                    >
                        Remove Driver
                    </button>

                    <button
                        class="cancel-driver-button"
                        :disabled="updatingTripSheetDriver"
                        @click="closeDriverPopup"
                    >
                        Cancel
                    </button>

                    <button
                        class="confirm-driver-button"
                        :disabled="
                            !selectedDriver ||
                            updatingTripSheetDriver
                        "
                        @click="updateTripSheetDriver"
                    >
                        {{
                            updatingTripSheetDriver
                                ? "Updating..."
                                : selectedTripSheetObject?.driverCode
                                    ? "Update Driver"
                                    : "Assign Driver"
                        }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)"  class="svg-container">
            <div class="svg-inner-container">
                <p>Delivery</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#32ccfe" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#32ccfe"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">1</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Pickup</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#33f18a" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#33f18a"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">2</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Depot</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#fe804d" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#fe804d"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">3</text>
                </svg>
            </div>
            <!-- <div class="svg-inner-container">
                <p>Delivered</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#000000" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#000000"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">4</text>
                </svg>
            </div> -->
        </div>
        <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0) && (manifestedSuccessfully == false)" class="button-container">
            <button class="refresh-button" @click="refreshMap()">Refresh</button>
        </div>
    </div>
  <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)" class="insert-stop-toggle-container">
    <button class="insert-stop-toggle-button" @click="toggleInsertStop()">
      {{ showInsertStop ? "Close Insert Stop" : "Insert Stop" }}
    </button>
  </div>
  <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0) && showInsertStop" class="insert-stop-container">
    <div class="insert-stop-header">
      <h3>Insert Stop</h3>
      <p class="insert-stop-subtext">Add one or more shipments to this trip sheet after an existing stop.</p>
    </div>
    <div class="insert-stop-body">
      <div class="insert-stop-field">
        <label>Insert after stop</label>
        <select class="insert-stop-input" v-model="insertAfterStop" :disabled="insertingStop">
          <option v-for="stopOption in insertableStops" :key="stopOption" :value="stopOption">Stop #{{ stopOption }}</option>
        </select>
      </div>
      <div class="insert-stop-field">
        <label>Shipment ID (type or scan)</label>
        <input
          type="text"
          class="insert-stop-input"
          v-model="insertShipmentID"
          placeholder="Scan or type shipment ID, then Add"
          :disabled="insertingStop"
          @keyup.enter="addShipmentToList()"
        />
      </div>
      <div class="insert-stop-field insert-stop-action">
        <button class="insert-stop-button insert-stop-add-button" :disabled="insertingStop || !insertShipmentID" @click="addShipmentToList()">
          Add
        </button>
      </div>
    </div>

    <div v-if="insertShipmentList.length > 0" class="insert-stop-chips">
      <div class="insert-stop-chip" v-for="(sid, index) in insertShipmentList" :key="index">
        <span>{{ sid }}</span>
        <button class="insert-stop-chip-remove" :disabled="insertingStop" @click="removeShipmentFromList(index)">×</button>
      </div>
    </div>

    <div class="insert-stop-review-row">
      <span class="insert-stop-count">{{ insertShipmentList.length }} shipment(s) added</span>
      <button class="insert-stop-button" :disabled="preparingInsert || insertShipmentList.length === 0" @click="insertStop()">
        {{ preparingInsert ? "Loading..." : "Review & Insert" }}
      </button>
    </div>
  </div>

  <div v-if="showInsertPreview && insertPreview" class="insert-preview-overlay" @click.self="closeInsertPreview()">
    <div class="insert-preview-popup">
      <div class="insert-preview-header">
        <h2>Confirm New Stop</h2>
        <button class="insert-preview-close" @click="closeInsertPreview()">×</button>
      </div>

      <p class="insert-preview-subtext">
        The following {{ insertPreview.shipments.length }} shipment(s) will be added after
        <strong>Stop #{{ insertPreview.afterStop }}</strong> on trip sheet {{ selectedTripSheetID }}:
      </p>

      <div class="insert-preview-shipments">
        <div class="insert-preview-shipment" v-for="(ship, index) in insertPreview.shipments" :key="index">
          <div class="insert-preview-shipment-top">
            <span class="insert-preview-shipment-id">{{ ship.shipmentID }}</span>
            <span class="insert-preview-shipment-company">{{ ship.address.companyName || "—" }}</span>
          </div>
          <div class="insert-preview-shipment-address">
            {{ ship.address.address1 }}, {{ ship.address.city }}, {{ ship.address.state }} {{ ship.address.zipCode }}
          </div>
          <div v-if="ship.pickupAddress" class="insert-preview-shipment-address insert-preview-pickup-address">
            <span class="insert-preview-pickup-label">Pickup:</span>
            {{ ship.pickupAddress.companyName ? ship.pickupAddress.companyName + " — " : "" }}{{ ship.pickupAddress.address1 }}, {{ ship.pickupAddress.city }}, {{ ship.pickupAddress.state }} {{ ship.pickupAddress.zipCode }}
          </div>

          <div v-if="ship.historyKey" class="insert-preview-error">
            <strong>Cannot insert.</strong> This shipment is in the history index. Reopen it to add it to a trip.
            <div v-if="ship.latestActivity" class="insert-preview-activity">
              <span class="insert-preview-activity-title">Latest activity:</span>
              <span>{{ ship.latestActivity.code }} — {{ ship.latestActivity.description }}</span>
              <span class="insert-preview-activity-time">{{ ship.latestActivity.activityTime }}</span>
            </div>
          </div>

          <div v-if="ship.existingTripSheets && ship.existingTripSheets.length > 0" class="insert-preview-warning">
            Already on trip sheet(s): <span class="insert-preview-warning-sheets">{{ ship.existingTripSheets.join(", ") }}</span>.
          </div>

          <div v-if="ship.routeCodeMismatch" class="insert-preview-warning">
            Original route <span class="insert-preview-warning-sheets">{{ ship.shipmentRouteCode }}</span>
            differs from this trip's route <span class="insert-preview-warning-sheets">{{ ship.tripRouteCode }}</span>. Can still be added.
          </div>
        </div>
      </div>

      <div v-if="insertPreview.anyHistoryBlocked" class="insert-preview-error">
        One or more shipments are in the history index and must be removed from the list before you can insert.
      </div>

      <div class="insert-preview-buttons">
        <button class="insert-preview-cancel" :disabled="insertingStop" @click="closeInsertPreview()">Cancel</button>
        <button class="insert-preview-confirm" :disabled="insertingStop || insertPreview.anyHistoryBlocked" @click="confirmInsertStop()">
          {{ insertingStop ? "Creating..." : "Confirm & Create" }}
        </button>
      </div>
    </div>
  </div>
  <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)" class="map-search-wrapper">
    <div ref="awsmap" id="map" />
    <div class="map-search-box">
      <input
        type="text"
        class="map-search-input"
        v-model="shipmentSearchQuery"
        placeholder="Search shipments by ID, company, or address"
      />
      <div class="map-search-results" v-if="shipmentSearchResults.length > 0">
        <div
          class="map-search-result"
          v-for="(result, index) in shipmentSearchResults"
          :key="index"
          @click="selectSearchResult(result)"
        >
          <span class="map-search-result-company">{{ result.address && result.address.companyName ? result.address.companyName : result.shipment.shipmentID }}</span>
          <span class="map-search-result-address" v-if="result.address">{{ result.address.address1 }}, {{ result.address.city }}, {{ result.address.state }} {{ result.address.zipCode }}</span>
          <span class="map-search-result-id">ID: {{ result.shipment.shipmentID }} · Stop #{{ result.stop }}</span>
        </div>
      </div>
      <div class="map-search-results" v-else-if="shipmentSearchQuery.trim().length >= 2">
        <div class="map-search-no-result">No shipments found</div>
      </div>
    </div>
  </div>
  <loading-skeleton :loadingHeight="'50vh'" v-if="loadingManifestData"/>

  <trip-waypoint-table v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0 && toggleWaypointTable)" :cognitoUser="user" :userData="userData" :filterByTripSheetID="selectedTripSheetID"/>

    <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0 && toggleWaypointTable) && (manifestMapData?.length > 0) && (manifestMapData[0]?.route)" class="data-container-main">
        <div class="table-container">
            <div class="manifest-text-container">
                <h3>Queued Activities</h3>
            </div>
            <queued-activities-table @refreshAfterVoid="refreshAfterVoid($event)" :cognitoUser="user" :selectedShipment="selectedShipment" :userData="userData" :filterByRoute="manifestMapData[0].route"/>
        </div>
    </div>

  <shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :cognitoUser="user" :trackShipmentID="popUpSelectedShipmentID"/>

  <div v-if="showDragAddressSuggestion" class="alert-container">
      <div class="inner-container">
          <div class="text-container">
            <div class="header-outer-container">
                <div class="header-container">
                    <svg style="width: 15px;
                    height: 15px;
                    padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                    <h3 style="margin: 0">{{popUpSelectedShipmentID}}</h3>
                </div>  
            </div>
            
            <p>{{autoCompleteData[0].Place.Label}}</p>
            <button class="cancel-button" @click="closeAddressSuggestion()">Cancel</button>
          </div>
      </div>
  </div>
  <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
</template>

<script>
import { Auth, Signer, API } from 'aws-amplify'
import Location from "aws-sdk/clients/location";
import maplibregl from 'maplibre-gl'
import AWS from '../../aws-exports'
import 'maplibre-gl/dist/maplibre-gl.css';
import ShipmentInfo from '../ShipmentDashboard/ShipmentInfo.vue'
import LoadingSkeleton from '../ShipmentDashboard/LoadingSkeleton.vue'
import AlertUser from '../Popups/AlertUser.vue';
import TripWaypointTable from '../ShipmentDashboard/ManifestDashboard/TripWaypointTable.vue'
import LoadingData from '../../components/Popups/LoadingData.vue';
import QueuedActivitiesTable from '../ShipmentDashboard/QueuedActivitiesDashboard/QueuedActivitiesTable.vue'
import DriverTable from '../ShipmentDashboard/DriverDashboard/DriverTable.vue'

export default {
    data(){
        return{
            toggleTrackShipment: false,
            manifestTripSheetID: null,
            manifestedSuccessfully: false,
            showDragAddressSuggestion: false,
            loadingDespatch: false,
            newLatitude: "",
            newLongitude: "",
            autoCompleteData: [],
            credentials: null,
            user: {},
            mapCenter: [],
            popUpSelectedShipmentID: "",
            manifestMapData: [],
            selectedRoute: "",
            toggleAlertBox: false,
            alertMessage: "",
            loadingManifestData: false,
            routeTableData: [],
            selectedRouteObject: {},
            toggleWaypointTable: true,
            selectedTripSheetObject: {},
            toggleDriverPopup: false,
            selectedDriver: null,
            updatingTripSheetDriver: false,
            showAbandonTripPopup: false,
            abandoningTrip: false,
            mapInstance: null,
            waypointMarkers: [],
            shipmentSearchQuery: "",
            insertShipmentID: "",
            insertShipmentList: [],
            insertAfterStop: "",
            insertingStop: false,
            showInsertStop: false,
            preparingInsert: false,
            showInsertPreview: false,
            insertPreview: null
        }
    },
    components:{
        ShipmentInfo,
        LoadingSkeleton,
        AlertUser,
        TripWaypointTable,
        LoadingData,
        QueuedActivitiesTable,
        DriverTable
    },
    watch:{
        async 'selectedTripSheetID'(){
            await this.getManifestShipmentData()
            await this.getTripSheetData();
            // await this.getRouteData();
            if(this.manifestMapData.length > 0){
                // if((this.manifestMapData[0].longitude != "")){
                    this.mapCreate();
                // }
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        }
    },
    props:['showPickupLogic', 'routeData', 'userData', 'selectedTripSheetID'],
    mounted: async function () {
        this.credentials = await Auth.currentCredentials()

        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.listRouteData();
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
        await this.getManifestShipmentData()
        await this.getTripSheetData()
        if(this.manifestMapData.length > 0){
                this.mapCreate();
        }else{
            this.toggleAlertBox = true;
            this.alertMessage = "No manifest data available";
            this.selectedRoute = "";
        }

        // setInterval(() => {
        //     this.refreshMap();
        // }, 30000);
    },
    unmounted(){
        //Reset hash allow map to adjust to address changes
        window.location.hash = ""
        this.mapInstance = null;
    },
    computed:{
        insertableStops(){
            // Unique, sorted list of existing stop numbers the user can insert after.
            const stops = this.manifestMapData
                .map(waypoint => waypoint.stop)
                .filter(stop => stop !== null && stop !== undefined && stop !== "");
            return [...new Set(stops)].sort((a, b) => Number(a) - Number(b));
        },
        shipmentSearchResults(){
            const query = this.shipmentSearchQuery.trim().toLowerCase();
            if(query.length < 2) return [];
            const results = [];
            this.manifestMapData.forEach((waypoint, waypointIndex) => {
                (waypoint.shipments || []).forEach(shipment => {
                    const address = shipment.address || {};
                    const fields = [
                        shipment.shipmentID,
                        address.companyName,
                        address.address1,
                        address.address2,
                        address.city,
                        address.state,
                        address.zipCode
                    ];
                    if(fields.some(field => field && field.toString().toLowerCase().includes(query))){
                        results.push({ shipment, address, waypointIndex, stop: waypoint.stop });
                    }
                });
            });
            return results.slice(0, 10);
        }
    },
    methods:{
        selectSearchResult(result){
            this.shipmentSearchQuery = "";
            this.highlightWaypoint(result.waypointIndex);
        },
        highlightWaypoint(waypointIndex){
            const marker = this.waypointMarkers?.[waypointIndex];
            const map = this.mapInstance;
            if(!marker || !map) return;

            const lngLat = marker.getLngLat();
            map.flyTo({
                center: [lngLat.lng, lngLat.lat],
                zoom: 15,
                essential: true
            });
            marker.togglePopup();

            const el = marker.getElement();
            el.style.transition = 'transform 0.2s ease';
            el.style.transform += ' scale(1.5)';
            setTimeout(() => {
                el.style.transform = el.style.transform.replace(' scale(1.5)', '');
            }, 1000);
        },
        closeAbandonTripPopup() {
            if (this.abandoningTrip) {
                return;
            }

            this.showAbandonTripPopup = false;
        },

        async confirmAbandonTrip() {
            if (!this.selectedTripSheetID || this.abandoningTrip) {
                return;
            }

            this.abandoningTrip = true;

            try {
                await this.abandonTrip();
                this.showAbandonTripPopup = false;
            } catch (error) {
                console.error("Failed to abandon trip:", error);
            } finally {
                this.abandoningTrip = false;
            }
        },

        async abandonTrip() {
            this.loadingDespatch = true;

            const input = {
                routeId: 0,
                abandonTrip: true,
                tripSheetID: String(this.selectedTripSheetID)
            };

            const manifestCreateTripMutation = `
                mutation ManifestCreateTrip($input: manifestCreateTripInput!) {
                    manifestCreateTrip(input: $input) {
                        tripSheetID
                    }
                }
            `;

            try {
                const manifestCreateTripData = await API.graphql({
                    query: manifestCreateTripMutation,
                    variables: {
                        input
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                console.log(
                    "Abandon Trip Response:",
                    manifestCreateTripData.data.manifestCreateTrip
                );

                await this.updateTripSheetDriver(
                    this.selectedTripSheetID,
                    ""
                );

                this.showAbandonTripPopup = false;

                this.toggleAlertBox = true;
                this.alertMessage = "Trip abandoned successfully.";

                this.$router.replace({
                    path: "/TripSheetDashboard"
                }).then(() => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                });
            } catch (e) {
                console.log("Full Error:", JSON.stringify(e, null, 2));

                this.toggleAlertBox = true;
                this.alertMessage =
                    e?.errors?.[0]?.message ||
                    e?.message ||
                    "Unable to abandon trip.";

                throw e;
            } finally {
                this.loadingDespatch = false;
            }
        },
        async checkBoxDriverCode(event){
            console.log(event)
            this.selectedDriver = event;
        },
        openDriverPopup() {
            this.selectedDriver = null;
            this.toggleDriverPopup = true;
        },

        closeDriverPopup() {
            this.toggleDriverPopup = false;
            this.selectedDriver = null;
        },

        // Fetch a driver's vendor by driverCode. Returns the vendor string, or null when the
        // driver has none or the lookup fails (non-fatal — assignment still proceeds).
        async getDriverVendor(driverCode) {
            if (!driverCode) return null;
            const getDriverQuery = `
                query GetDriverForVendor($driverCode: String!) {
                    getDriver(driverCode: $driverCode) {
                        driverCode
                        vendor
                    }
                }
            `;
            try {
                const response = await API.graphql({
                    query: getDriverQuery,
                    variables: { driverCode },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });
                return response?.data?.getDriver?.vendor || null;
            } catch (error) {
                console.error("Error fetching driver vendor:", error);
                return null;
            }
        },

        async updateTripSheetDriver() {
            if (!this.selectedDriver) {
                this.toggleAlertBox = true;
                this.alertMessage = "Please select a driver.";
                return;
            }

            const tripSheetId = Number(this.selectedTripSheetID);

            if (!tripSheetId) {
                this.toggleAlertBox = true;
                this.alertMessage = "A valid Trip Sheet ID is required.";
                return;
            }

            this.updatingTripSheetDriver = true;

            // Look up the selected driver's vendor so the trip sheet carries it for the
            // vendor cost pipeline. If the driver has no vendor, leave the trip's vendor as-is.
            const driverVendor = await this.getDriverVendor(this.selectedDriver);

            const updateTripSheetMutation = `
                mutation UpdateTripSheet(
                    $input: UpdateTripSheetInput!
                ) {
                    updateTripSheet(input: $input) {
                        TripSheetId
                        DriverId
                        RouteId
                        driverCode
                        routeCode
                        vehicleCode
                        vendor
                        costStatus
                        openSince
                        closedOn
                        openManifestAction
                        serviceStatus
                        serviceTime
                        lastScanTime
                    }
                }
            `;

            const input = {
                TripSheetId: tripSheetId,
                driverCode: this.selectedDriver,
                // A trip becomes cost-reviewable only once a driver (and its vendor) is assigned.
                // Trips are created with no costStatus, so this is what surfaces the trip on the
                // Trip Cost Approval dashboard (which queries costStatus = "open").
                costStatus: "open",
                // openSince is the byCostStatus GSI sort key (the dashboard sorts on it). Keep an
                // existing value; otherwise stamp today's date so the GSI entry sorts correctly.
                openSince: this.selectedTripSheetObject?.openSince || new Date().toISOString().slice(0, 10)
            };
            if (driverVendor) {
                input.vendor = driverVendor;
            }

            try {
                const response = await API.graphql({
                    query: updateTripSheetMutation,
                    variables: { input },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                const updatedTripSheet =
                    response.data.updateTripSheet;

                this.selectedTripSheetObject =
                    updatedTripSheet;

                this.toggleAlertBox = true;
                this.alertMessage =
                    "Trip sheet driver updated.";

                this.closeDriverPopup();
            } catch (error) {
                console.error(
                    "Error updating trip sheet driver:",
                    error
                );

                this.toggleAlertBox = true;
                this.alertMessage =
                    "Error updating trip sheet driver.";
            } finally {
                this.updatingTripSheetDriver = false;
            }
        },
        async removeTripSheetDriver() {

            const tripSheetId = Number(this.selectedTripSheetID);

            if (!tripSheetId) {
                this.toggleAlertBox = true;
                this.alertMessage = "A valid Trip Sheet ID is required.";
                return;
            }

            this.updatingTripSheetDriver = true;

            const updateTripSheetMutation = `
                mutation UpdateTripSheet(
                    $input: UpdateTripSheetInput!
                ) {
                    updateTripSheet(input: $input) {
                        TripSheetId
                        DriverId
                        RouteId
                        driverCode
                        routeCode
                        vehicleCode
                        vendor
                        costStatus
                        openSince
                        closedOn
                        openManifestAction
                        serviceStatus
                        serviceTime
                        lastScanTime
                    }
                }
            `;

            try {
                const response = await API.graphql({
                    query: updateTripSheetMutation,
                    variables: {
                        input: {
                            TripSheetId: tripSheetId,
                            driverCode: "Not Assigned",
                            // The trip's vendor is derived from the assigned driver, so clear it
                            // when the driver is removed. Leaving a stale vendor would let the
                            // trip be approved against a vendor it no longer has a driver for.
                            vendor: null,
                            // Removing the driver takes the trip back off the Trip Cost Approval
                            // dashboard: clearing costStatus drops it out of the costStatus = "open"
                            // GSI query (it only becomes reviewable again once a driver is assigned).
                            costStatus: null
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                const updatedTripSheet =
                    response.data.updateTripSheet;

                this.selectedTripSheetObject =
                    updatedTripSheet;

                this.toggleAlertBox = true;
                this.alertMessage =
                    "Trip sheet driver removed.";

                this.closeDriverPopup();
            } catch (error) {
                console.error(
                    "Error updating trip sheet driver:",
                    error
                );

                this.toggleAlertBox = true;
                this.alertMessage =
                    "Error updating trip sheet driver.";
            } finally {
                this.updatingTripSheetDriver = false;
            }
        },
        async reOpenManifest(){

            let updateRouteTable = `mutation updateRoute{
            updateRoute(input: {routeCode: "${this.selectedRoute}", manifestStatus: "Dispatched"}) {
                    routeCode
                    openManifestAction
                    routeId
                    manifestCutoffTime
                }
            }
            `

            try{
                let updateRouteTableData = await API.graphql({
                query:  updateRouteTable,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", updateRouteTableData.data);
                this.toggleAlertBox = true;
                this.alertMessage = "Route status updated"
                this.$emit('toggleOpenManifestMap', {showOpenManifest: true})
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async getTripSheetData() {
            const tripSheetId = Number(this.selectedTripSheetID);

            if (!tripSheetId) {
                this.toggleAlertBox = true;
                this.alertMessage = "A valid Trip Sheet ID is required.";
                return;
            }

            const queryTripSheetTable = `
                query GetTripSheet($TripSheetId: Int!) {
                    getTripSheet(TripSheetId: $TripSheetId) {
                        TripSheetId
                        DriverId
                        RouteId
                        VehicleId
                        TripDate
                        SignOffDate
                        StartingMileage
                        SignOffId
                        EndingMileage
                        ManifestSource
                        driverCode
                        routeCode
                        vehicleCode
                        openSince
                        closedOn
                        openManifestAction
                        serviceStatus
                        serviceTime
                        lastScanTime
                    }
                }
            `;

            try {
                const response = await API.graphql({
                    query: queryTripSheetTable,
                    variables: {
                        TripSheetId: tripSheetId
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                console.log("Trip Sheet Data:", response.data.getTripSheet);

                this.selectedTripSheetObject = response.data.getTripSheet;

                if (!this.selectedTripSheetObject) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Trip sheet not found.";
                }
            } catch (error) {
                console.error("Error getting trip sheet data:", error);

                this.toggleAlertBox = true;
                this.alertMessage = "Error getting trip sheet data.";
                this.selectedTripSheetObject = null;
            }
        },
        async getRouteData(){
            let input = {
                input:{
                    routeCode: this.selectedRoute
                }
            }
            let queryRouteTable = `query getRoute{
            getRoute(routeCode: "${this.selectedRoute}") {
                    routeCode
                    openManifestAction
                    routeId
                    manifestCutoffTime
                }
            }
            `

            try{
                let queryRouteTableData = await API.graphql({
                query:  queryRouteTable,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", queryRouteTableData.data.getRoute);
                this.selectedRouteObject = queryRouteTableData.data.getRoute;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async manifestCreateTripFunc(){
            let manifestsToDespatchValue = "Open";
            this.loadingDespatch = true;

            let input = {
                input:{
                    routeId: this.selectedRouteObject.routeId,
                    manifestsToDespatch: [manifestsToDespatchValue]
                }
            }
            let manifestCreateTrip = `mutation manifestCreateTrip{
            manifestCreateTrip(input: {routeId: ${this.selectedRouteObject.routeId}, manifestsToDespatch: ["${manifestsToDespatchValue}"]}) {
                    tripSheetID
                }
            }
            `

            try{
                let manifestCreateTripData = await API.graphql({
                query:  manifestCreateTrip,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("manifestCreateTrip Data: ", manifestCreateTripData.data.manifestCreateTrip.tripSheetID);
                this.loadingDespatch = false;
                this.manifestTripSheetID = manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
                this.manifestedSuccessfully = true;
                return manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting manifestCreateTrip data"
                }
                this.loadingDespatch = false;
                this.manifestedSuccessfully = false;
                throw new Error("Manifest Create Trip Failed: ", e)
            }
        },
        async refreshMap(){
            await this.getManifestShipmentData()
            await this.getTripSheetData()
            if(this.manifestMapData.length > 0){
                    this.mapCreate();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        },
        getLatestActivity(activity){
            if(!Array.isArray(activity) || activity.length === 0) return null;
            // Return the activity with the most recent activityTime.
            return [...activity].sort((a, b) => {
                const timeA = a?.activityTime ? new Date(a.activityTime).getTime() : 0;
                const timeB = b?.activityTime ? new Date(b.activityTime).getTime() : 0;
                return timeB - timeA;
            })[0];
        },
        toggleInsertStop(){
            this.showInsertStop = !this.showInsertStop;
            // Default "Insert after stop" to the first stop on the trip.
            if(this.showInsertStop && !this.insertAfterStop && this.insertableStops.length > 0){
                this.insertAfterStop = this.insertableStops[0];
            }
        },
        addShipmentToList(){
            const sid = (this.insertShipmentID || "").trim();
            if(!sid) return;
            if(this.insertShipmentList.includes(sid)){
                this.toggleAlertBox = true;
                this.alertMessage = "That shipment ID is already in the list.";
                this.insertShipmentID = "";
                return;
            }
            this.insertShipmentList.push(sid);
            this.insertShipmentID = "";
        },
        removeShipmentFromList(index){
            this.insertShipmentList.splice(index, 1);
        },
        async getShipmentForInsert(shipmentID){
            const getShipmentQuery = `query getShipment{
                getShipment(shipmentID: "${shipmentID}"){
                    shipmentID
                    service
                    historyKey
                    activity{
                        code
                        description
                        activityTime
                    }
                    serviceAddress{
                        address{
                            companyName
                            address1
                            city
                            state
                            zipCode
                            routeCode
                        }
                    }
                    deliveryPickup{
                        address{
                            companyName
                            address1
                            city
                            state
                            zipCode
                            routeCode
                        }
                    }
                }
            }`;

            const response = await API.graphql({
                query: getShipmentQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS"
            });
            return response.data.getShipment;
        },
        async checkExistingTripShipment(shipmentID){
            // Returns list of distinct trip sheet IDs this shipment already exists on.
            const query = `query TripShipmentByShipmentID($shipmentID: String!, $nextToken: String){
                tripShipmentByShipmentID(shipmentID: $shipmentID, nextToken: $nextToken){
                    items{
                        tripSheetID
                        assignedShippingEvent
                    }
                    nextToken
                }
            }`;

            let tripSheetIDs = [];
            let nextToken = null;
            do {
                const response = await API.graphql({
                    query,
                    variables: { shipmentID, nextToken },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });
                const data = response.data.tripShipmentByShipmentID;
                (data.items || []).forEach(item => {
                    if(item.tripSheetID) tripSheetIDs.push(item.tripSheetID);
                });
                nextToken = data.nextToken;
            } while (nextToken);

            return [...new Set(tripSheetIDs)];
        },
        async insertStop(){
            // Builds a lightweight per-shipment preview and opens the confirmation popup.
            // The addToTrip Lambda does all the record creation logic; the UI only
            // sends the existing stop we want to insert after and the shipment IDs.
            if(this.insertingStop || this.preparingInsert) return;

            if(this.insertShipmentList.length === 0){
                this.toggleAlertBox = true;
                this.alertMessage = "Please add at least one shipment ID.";
                return;
            }

            this.preparingInsert = true;

            try {
                const tripRouteCode = this.manifestMapData[0]?.route || "";
                const shipments = [];

                for(const sid of this.insertShipmentList){
                    const shipment = await this.getShipmentForInsert(sid);

                    if(!shipment){
                        // Show it in the list but flagged as not found via empty address.
                        shipments.push({
                            shipmentID: sid,
                            address: { companyName: "Shipment not found", address1: "", city: "", state: "", zipCode: "" },
                            existingTripSheets: [],
                            shipmentRouteCode: "",
                            tripRouteCode,
                            routeCodeMismatch: false,
                            historyKey: null,
                            latestActivity: null
                        });
                        continue;
                    }

                    const isPickupService = (shipment.service || "").toLowerCase() === "pickup";
                    const addressSource = shipment.serviceAddress?.address || shipment.deliveryPickup?.address || {};
                    const shipmentRouteCode = addressSource.routeCode || "";
                    const routeCodeMismatch = shipmentRouteCode && tripRouteCode && (shipmentRouteCode !== tripRouteCode);
                    const existingTripSheets = await this.checkExistingTripShipment(shipment.shipmentID);

                    // For a pickup service, also surface the delivery/pickup address.
                    const pickupAddressSource = shipment.deliveryPickup?.address;
                    const pickupAddress = (isPickupService && pickupAddressSource) ? {
                        companyName: pickupAddressSource.companyName || "",
                        address1: pickupAddressSource.address1 || "",
                        city: pickupAddressSource.city || "",
                        state: pickupAddressSource.state || "",
                        zipCode: pickupAddressSource.zipCode || ""
                    } : null;

                    shipments.push({
                        shipmentID: shipment.shipmentID,
                        address: {
                            companyName: addressSource.companyName || "",
                            address1: addressSource.address1 || "",
                            city: addressSource.city || "",
                            state: addressSource.state || "",
                            zipCode: addressSource.zipCode || ""
                        },
                        pickupAddress,
                        existingTripSheets,
                        shipmentRouteCode,
                        tripRouteCode,
                        routeCodeMismatch,
                        historyKey: shipment.historyKey || null,
                        latestActivity: this.getLatestActivity(shipment.activity)
                    });
                }

                this.insertPreview = {
                    afterStop: Number(this.insertAfterStop),
                    shipments,
                    anyHistoryBlocked: shipments.some(s => !!s.historyKey)
                };
                this.showInsertPreview = true;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = e?.errors?.[0]?.message || e?.message || "Unable to prepare stop.";
            } finally {
                this.preparingInsert = false;
            }
        },
        closeInsertPreview(){
            if(this.insertingStop) return;
            this.showInsertPreview = false;
            this.insertPreview = null;
        },
        async confirmInsertStop(){
            if(this.insertingStop || !this.insertPreview) return;
            if(this.insertPreview.anyHistoryBlocked){
                this.toggleAlertBox = true;
                this.alertMessage = "Remove the history-index shipment(s) from the list before inserting.";
                return;
            }

            this.insertingStop = true;
            const preview = this.insertPreview;

            const input = {
                tripSheetID: String(this.selectedTripSheetID),
                stops: [{
                    stop: preview.afterStop,
                    shipments: preview.shipments.map(s => s.shipmentID)
                }]
            };

            const addToTripMutation = `mutation AddToTrip($input: AddToTripInput!){
                addToTrip(input: $input){
                    statusCode
                    status
                    body
                }
            }`;

            try {
                const response = await API.graphql({
                    query: addToTripMutation,
                    variables: { input },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                const result = response.data.addToTrip;
                const status = result?.status;

                // The Lambda returns per-shipment errors inside a JSON body.
                // The body can be double-encoded (a JSON string containing a JSON string),
                // so keep parsing until we get an object.
                let messages = [];
                if(result?.body){
                    try {
                        let parsed = result.body;
                        let guard = 0;
                        while(typeof parsed === "string" && guard < 5){
                            parsed = JSON.parse(parsed);
                            guard++;
                        }
                        if(parsed && Array.isArray(parsed.result)){
                            parsed.result.forEach(r => {
                                (r.errors || []).forEach(err => messages.push(err));
                            });
                        }
                        if(parsed && Array.isArray(parsed.error)){
                            parsed.error.forEach(err => messages.push(err));
                        }
                    } catch (parseErr) {
                        console.log("Unable to parse addToTrip body", parseErr);
                    }
                }

                if(status === "Success"){
                    this.alertMessage = "Stop inserted after #" + preview.afterStop + ".";
                }else if(status === "PartialSuccess"){
                    this.alertMessage = messages.length
                        ? "Stop inserted with warnings: " + messages.join("; ")
                        : "Stop inserted with warnings.";
                }else{
                    this.alertMessage = messages.length
                        ? messages.join("; ")
                        : "Unable to insert stop.";
                }
                this.toggleAlertBox = true;

                // Always close the preview popup once the mutation returns.
                this.showInsertPreview = false;
                this.insertPreview = null;

                // Only clear the list + refresh the map when something was actually added.
                if(status === "Success" || status === "PartialSuccess"){
                    this.insertShipmentID = "";
                    this.insertShipmentList = [];
                    this.insertAfterStop = this.insertableStops.length > 0 ? this.insertableStops[0] : "";
                    await this.refreshMap();
                }
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = e?.errors?.[0]?.message || e?.message || "Unable to insert stop.";
                this.showInsertPreview = false;
                this.insertPreview = null;
            } finally {
                this.insertingStop = false;
            }
        },
        async selectRouteCode(event){
            this.manifestedSuccessfully = false;
            this.manifestTripSheetID = null;
            this.selectedRoute = "";
            this.isoDateTime = "";
            this.manifestMapData = []
            console.log(event)
            this.selectedRoute = event.routeCode;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        trackShipment(){
            this.toggleTrackShipment = true;
        },
        closeShipmentInfo(){
            this.toggleTrackShipment = false;
        },
        closeAddressSuggestion(){
            this.showDragAddressSuggestion = false;
        },
        async getManifestShipmentData() {
            this.toggleWaypointTable = false;
            this.loadingManifestData = true;
            this.manifestMapData = []
            let tripSheetID = this.selectedTripSheetID;
            let graphqlQuery = `query listTripWaypoints($nextToken: String, $tripSheetID: String) {
                listTripWaypoints(nextToken: $nextToken, tripSheetID: $tripSheetID) {
                    items{
                        tripSheetID
                        stop
                        longitude
                        latitude
                        route
                        geometry
                        waypoint
                        arrival
                        departure
                        stopType
                        isDelivery
                        windowEnd
                        windowStart
                        shipments{
                        shipmentID
                            address{
                                address1
                                address2
                                latitude
                                longitude
                                city
                                companyName
                                zipCode
                                state
                            }
                        shipmentID
                        isPriority
                        signatureRequired
                        lastActivity{
                            activityTime
                            description
                            code
                            }
                        }
                    }
                    nextToken
                }
            }`;

            console.log(graphqlQuery)

            try {
                let allTripShipments = [];
                let nextToken = null;

                do {
                    let response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                        variables: { nextToken, tripSheetID }
                    });

                    const data = response.data.listTripWaypoints;
                    allTripShipments = [...allTripShipments, ...data.items];
                    nextToken = data.nextToken;

                } while (nextToken); 
                this.manifestMapData = [];
                this.manifestMapData = allTripShipments;
                //console.log(this.manifestMapData)
                this.toggleWaypointTable = true;
                this.loadingManifestData = false;
            } catch (e) {
                console.log(e)
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting waypoint data"
                this.loadingManifestData = false;
            }
        },
        async getLocationData(lng, lat){
            const credentials = await Auth.currentCredentials();

            const locationClient = new Location({
                credentials,
                region: 'us-east-1'
            });

            const params = {
                IndexName: "lrex-place",
                Position: [lng, lat],
                MaxResults: 5
            };

                locationClient.searchPlaceIndexForPosition(params,(err,data)=>{
                    if(err){
                        alert("Error with Location Services.")
                    }
                    if(data){
                        //Only suggest addresses with Street and AddressNumber Values
                        if(data.Results[0]){
                            if(data.Results[0].Place.AddressNumber || data.Results[0].Place.Street){
                                this.autoCompleteData = data.Results;
                                this.showDragAddressSuggestion = true;
                                console.log("Address from lat long: ", this.autoCompleteData[0].Place)
                            }
                        }
                    }
                })
        },
        mapCreate: function() {
                let mapCenter = null;
                let geometry = null;
         
                for (const location of this.manifestMapData) {
                    console.log("Inside for loop")
                    if (location.latitude !== null && location.longitude !== null) {
                        mapCenter = [location.longitude, location.latitude];
                    }

                    if (location.waypoint === "*") {
                        geometry = location.geometry;
                    }

                    if (mapCenter !== null && geometry !== null) {
                        break;
                    }
                }

                this.waypointMarkers = [];

                const map = new maplibregl.Map({
                    container: 'map',
                    style: 'LREXSite-Map',
                    center: mapCenter,
                    zoom: 10,
                    bearing: 64.8,
                    pitch: 10,
                    hash: true,
                    transformRequest: this.transformRequest
                });

                this.mapInstance = map;

                map.on('load', ()=>{
                    for (let i = 0; i < geometry.length; i++) {
                        const element = geometry[i];
                        console.log(element)
                        map.addSource('routeline' + i, {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: element
                        }
                    }
                        })

                        map.addLayer({
                            id: 'routeline' + i,
                            type: 'line',
                            source: 'routeline' + i,
                            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#000',
                'line-width': 4
            }
                        });
                }
                    }
                    )


                let markerArray = [];
                // markerArray.push(stopRecord)
                for (let i = 0; i < this.manifestMapData.length; i++) {
                    const element = this.manifestMapData[i];
                    let shipmentInfo = '';
                    element.shipments?.forEach((shipment) => {
                        shipmentInfo += `<h3 style="margin: 0;">Shipment ID: ${shipment.shipmentID}</h3>`;
                        shipmentInfo += `<p style="margin: 0;">Address: ${shipment.address.address1}, ${shipment.address.city}, ${shipment.address.state}, ${shipment.address.zipCode}</p>`;
                    })
                    const popup = new maplibregl.Popup({
                            offset: 15,
                    }).setHTML(
                            `
                            <div style="display: flex;
                            flex-direction: row;
                            align-items: center;
                            background-color: #e4e4e4;
                            border-radius: 999px;
                            padding: 5px;
                            width: -moz-fit-content;
                            width: fit-content;
                            margin-bottom: 5px;">
                            <svg style="width: 15px;
                            height: 15px;
                            padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                            <h3 style="margin: 0">Route: ${element.route}</h3>
                            </div>
                            <h3 style="text-align: left; margin-bottom: 2.5px; margin-top: 2.5px;">Stop #: ${element.stop}</h3>
                            <p style="text-align: left; margin: 0;">Arrival Time: ${this.formatLocalTimeArrival(element.arrival)}</p>
                            <p style="text-align: left; margin: 0;">Departure Time: ${this.formatLocalTimeArrival(element.departure)}</p>
                            <div style="
                            max-height: 100px;
                            overflow-y: scroll;
                            text-align: left;
                            ">
                            ${shipmentInfo}
                            </div>
                            `
                    );

                    //stopType
                    //0 = Order (delivery or pickup)
                    //1 = Depot
                    //2 = Break
                    //isDelivery indicates if stop is pickup or delivery
                    //Priority is some comparison of time windows
                    let markerColor;
                    let deliveryColor = "#32ccfe";
                    let pickupColor = "#33f18a";
                    let depotColor = "#fe804d";
                    let breakColor = "#000000"

                    if(element.isDelivery == true && element.stopType == 0){
                        markerColor = deliveryColor;
                    }else if(element.isDelivery == false && element.stopType == 0){
                        markerColor = pickupColor;
                    }else if(element.stopType == 1){
                        markerColor = depotColor;
                    }else if(element.stopType == 2){
                        markerColor = breakColor;
                        
                    }

                    

                    // console.log("BREAK TYPE ", element)

                    if(!element.stop){
                        continue;
                    }

                    const svgString = `
                    <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="25" height="36" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="${markerColor}" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle stroke="${markerColor}" stroke-width="1" cx="12" cy="12" r="10.5" fill="${markerColor}"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#000" font-size="12" dy=".3em" font-weight = "bold">${element.stop}</text>
                    </svg>
                    `;

                    // Create a new div element and set its innerHTML to the SVG string
                    const svgElement = document.createElement('div');
                    svgElement.innerHTML = svgString;
                    
                    let mapMarker = 
                    new maplibregl.Marker({
                        color: markerColor,
                       element: svgElement
                    }).setLngLat([element.longitude, element.latitude])
                    .setPopup(popup)
                    .addTo(map);

                    markerArray.push(mapMarker)
                    this.waypointMarkers[i] = mapMarker;
                }
                console.log("Marker Array: ", markerArray)

                // let boundingArray = []
                // for (let i = 0; i < markerArray.length; i++) {
                //     const element = markerArray[i];
                //     boundingArray.push([element['_lngLat'].lng, element['_lngLat'].lat])
                // }

                // if (boundingArray.length > 0) {
                //     map.fitBounds(boundingArray, {padding: 50})
                // }

                // console.log("Bounding Array: ", boundingArray)
                const bounds = new maplibregl.LngLatBounds();

                for (const m of markerArray) {
                    const { lng, lat } = m.getLngLat();
                    bounds.extend([lng, lat]);
                }

                // 2) Guard single-marker case
                if (markerArray.length === 1) {
                    map.easeTo({ center: bounds.getCenter(), zoom: 14 });
                    } else if (!bounds.isEmpty()) {
                    // 3) If you have side panels or a bottom bar, pad appropriately
                    map.resize(); // if the container just changed size
                    map.setPitch(0); // optional: flatten to get a tighter fit
                    map.setBearing(0); // optional
                    map.fitBounds(bounds, {
                        padding: { top: 60, right: 60, bottom: 120, left: 60 },
                        maxZoom: 15,   // prevents zooming in too tight
                        duration: 0    // instant; or use 500 for animation
                    });
                }

                map.addControl(new maplibregl.NavigationControl());
            },
            transformRequest: function (url, resourceType) {
                if (resourceType === 'Style' && !url.includes('://')) {
                    url = `https://maps.geo.${AWS.aws_project_region}.amazonaws.com/maps/v0/maps/${url}/style-descriptor`
                }
                if (url.includes('amazonaws.com')) {
                    return {
                        url: Signer.signUrl(url, {
                            access_key: this.credentials.accessKeyId,
                            secret_key: this.credentials.secretAccessKey,
                            session_token: this.credentials.sessionToken,
                        }),
                    }
                }
                return { url }
            },
            formatLocalTimeArrival(time24) {
                if (typeof time24 !== 'string') return '';
                const [hours, minutes] = time24.split(":");
                const date = new Date();
                date.setHours(hours, minutes, 0, 0);

                // Format to a readable local 12-hour time
                const localTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

                return localTime;
            },
            async listRouteData(){
                let graphqlQuery = `query listRoutes{
                    listRoutes(limit: 300){
                        items{
                            routeCode
                            }
                        }
                    }`
                
                try{
                    let listRouteDataReturn = await API.graphql({
                    query:  graphqlQuery,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                    })
                    
                    this.routeTableData = listRouteDataReturn.data.listRoutes.items;
                }catch(e){
                    console.log(e)
                    if(e){
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error getting route codes"
                    }
                }
            }
    }
}
</script>

<style scoped>
/* @import 'node_modules/maplibre-gl/dist/maplibre-gl.css'; */
body { margin: 0; }
#map { 
    height: 60vh; 
    border-radius: 25px;
}

.map-search-wrapper {
    position: relative;
}

.map-search-box {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 5;
    width: 320px;
    max-width: 70%;
}

.map-search-input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 14px;
    font-size: 14px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    background-color: #fff;
}

.map-search-input:focus {
    border-color: #32ccfe;
}

.map-search-results {
    margin-top: 4px;
    background-color: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 300px;
    overflow-y: auto;
}

.map-search-result {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.15s ease;
}

.map-search-result:last-child {
    border-bottom: none;
}

.map-search-result:hover {
    background-color: #eef4fb;
}

.map-search-result-company {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
}

.map-search-result-address {
    font-size: 12px;
    color: #475569;
}

.map-search-result-id {
    font-size: 11px;
    color: #94a3b8;
}

.map-search-no-result {
    padding: 10px 12px;
    font-size: 13px;
    color: #94a3b8;
}

select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
    margin-bottom: 5px;
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: fit-content;

    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.svg-container h3{
    margin: 0;
}

.svg-inner-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 100px;
}

.svg-inner-container p{
    margin: 0;
}

.svg-inner-container svg{
    margin-left: 5px;
}

.update-driver-button {
    padding: 7px 16px;
    /* margin-left: 10px; */
    background-color: #32ccfe;
    color: #ffffff;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition-duration: 0.3s;
    display: block;
    width: fit-content;
    margin-left: 0;
    margin-right: auto;
}

.popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.5);
}

.abandon-trip-popup {
    width: 100%;
    max-width: 450px;
    padding: 24px;
    border-radius: 10px;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.abandon-trip-popup h2 {
    margin: 0 0 12px;
}

.abandon-trip-details {
    margin: 20px 0;
    padding: 15px;
    border-radius: 6px;
    background-color: #f5f5f5;
}

.abandon-trip-details p {
    margin: 6px 0;
}

.popup-button-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.cancel-button,
.confirm-abandon-button {
    padding: 10px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.cancel-button {
    background-color: #e5e5e5;
}

.confirm-abandon-button,
.abandon-trip-button {
    color: white;
    background-color: #c62828;
}

.cancel-button:disabled,
.confirm-abandon-button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.update-driver-button:hover {
    filter: brightness(0.92);
}

.update-trip-button {
    padding: 7px 16px;
    /* margin-left: 10px; */
    background-color: #d1d1d1;
    color: #a39e9e;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition-duration: 0.3s;
    display: block;
    width: fit-content;
    margin-top: 5px;
    margin-left: auto;
    margin-right: 0;
}

.update-trip-button:hover {
    filter: brightness(0.92);
}

.driver-popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 30px 15px;
    overflow-y: auto;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.45);
}

.driver-popup {
    width: min(750px, 100%);
    padding: 20px;
    background-color: #ffffff;
    border-radius: 20px;
    box-sizing: border-box;
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
}

.driver-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding-bottom: 12px;
    border-bottom: 1px solid #d5d5d5;
}

.driver-popup-header h2 {
    margin: 0;
}

.close-driver-popup {
    width: 34px;
    height: 34px;
    padding: 0;
    font-size: 26px;
    line-height: 1;
    color: #555555;
    background-color: #f1f1f1;
    border: none;
    border-radius: 999px;
    cursor: pointer;
}

.close-driver-popup:hover {
    background-color: #dddddd;
}

.driver-popup-details {
    padding: 15px;
    margin-top: 15px;
    background-color: #f5f5f5;
    border-radius: 15px;
}

.driver-detail-row {
    display: flex;
    gap: 8px;
    margin: 7px 0;
}

.driver-search-container {
    margin-top: 15px;
    background-color: #fff;
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    padding: 5px;
}

.driver-popup-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 15px;
    margin-top: 15px;
    border-top: 1px solid #d5d5d5;
}

.remove-driver-button{
    margin-left: 0;
    margin-right: auto;
}

.cancel-driver-button,
.confirm-driver-button {
    padding: 8px 18px;
    border: none;
    border-radius: 999px;
    cursor: pointer;
}

.cancel-driver-button {
    background-color: #e4e4e4;
}

.confirm-driver-button {
    background-color: #33f18a;
}

.confirm-driver-button:disabled,
.cancel-driver-button:disabled {
    background-color: #d5d5d5;
    cursor: not-allowed;
}

.driver-row {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding: 10px;
    margin-bottom: 8px;
    background-color: #f3f3f3;
    border: 1px solid transparent;
    border-radius: 10px;
    cursor: pointer;
}

.driver-row:hover {
    filter: brightness(0.96);
}

.selected-driver-row {
    border-color: #32ccfe;
    background-color: #e7f8fe;
}

@media only screen and (max-width: 600px) {
    .driver-popup-overlay {
        padding: 10px;
    }

    .driver-popup {
        padding: 15px;
        border-radius: 15px;
    }

    .driver-detail-row {
        flex-direction: column;
        gap: 2px;
    }

    .driver-popup-buttons {
        flex-direction: column-reverse;
    }

    .cancel-driver-button,
    .confirm-driver-button {
        width: 100%;
    }
}

.route-info{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.route-info-inner{
    width: 100%;
}

.manifest-header{
    text-align: left;
    background-color: #e4e4e4;
    width: fit-content;
    padding: 5px;
    border-radius: 999px;
    /* margin-bottom: 5px !important; */
    /* margin-top: 0; */
 }

 .print-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    height: fit-content;
    margin-left: 25px;
    /* margin-top: 5px; */
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.print-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.refresh-button{
    margin-right: 5px;
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.refresh-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.optimize-manifest-button{
    background-color: #fe804d;
    margin-left: 15px;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.optimize-manifest-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.update-shipment{
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
}

.despatch-info-container{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.manifest-text-container{
    display: flex;
    justify-content: flex-start;
 }

 .manifest-text-container h3{
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: #e4e4e4;
    padding: 5px;
    border-radius: 999px;
 }

 .manifest-text-container p{
    margin-top: 5px;
    margin-bottom: 5px;
 }

.alert-container{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        position: absolute;
        z-index: 99;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 90%, rgba(236, 236, 236, 0.05) 100%);
    }

    .inner-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .main-button-blue-white{
        margin: 5px;
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .text-container{
        background-color: #fff;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.475);
        border-radius: 15px;
        width: 30%;
        z-index: 99;
        text-align: center;
        position: absolute;
        top: 15%;
        animation: animate-alert .5s ease;
        max-height: 70vh;
        overflow-y: auto;

    }

    .header-container{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #e4e4e4;
        border-radius: 999px;
        padding: 5px;
        width: -moz-fit-content;
        width: fit-content;
        text-align: center;
    }

    .header-outer-container{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 5px;
    }

    .cancel-button{
        margin: 5px;
        background-color: #fe804d;
        color: #fff;
        border-radius: 15px;
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        transition-duration: .25s;
    }

    .cancel-button:hover{
        background-color: #d26a41;
        transition-duration: .25s;
    }

    .data-container-main{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .table-container{
        background-color: #fff;
        padding: 15px;
        border-radius: 25px;
        height: fit-content;
        flex-basis: 50%;
        margin: 10px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        display: flex;
        justify-content: center;
        /* align-items: center; */
        flex-direction: column;
    }

    @keyframes animate-alert {
        from{
            top: 10%;
            opacity: 0;
        }
        to{
            top: 15%;
            opacity: 1;
        }
    }

    @media screen and (max-width: 1000px) {
        .text-container{
            width: 70%;
        }
    }

    .insert-stop-container{
        width: 90%;
        max-width: 900px;
        margin: 10px auto;
        background-color: #fff;
        border: 1px solid #e2e2e2;
        border-radius: 15px;
        box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
        padding: 15px 20px;
        text-align: left;
    }

    .insert-stop-header h3{
        margin: 0;
        font-size: 17px;
    }

    .insert-stop-subtext{
        margin: 2px 0 12px 0;
        font-size: 12px;
        color: #6a6a6a;
    }

    .insert-stop-body{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 12px;
    }

    .insert-stop-field{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        flex: 1 1 180px;
        min-width: 150px;
    }

    .insert-stop-field label{
        font-size: 12px;
        color: #3f3f3f;
        margin-bottom: 4px;
        font-weight: bold;
        height: 16px;
        line-height: 16px;
    }

    .insert-stop-input{
        height: 42px;
        box-sizing: border-box;
        padding: 10px;
        font-size: 14px;
        border: 1px solid rgba(0,0,0,.2);
        border-radius: 10px;
        outline: none;
        background-color: #fff;
        margin: 0;
    }

    .insert-stop-input:focus{
        border-color: #32ccfe;
    }

    .insert-stop-action{
        flex: 0 0 auto;
    }

    .insert-stop-button{
        height: 42px;
        box-sizing: border-box;
        background-color: #33f18a;
        border: none;
        padding: 0 22px;
        border-radius: 999px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition-duration: .25s;
        white-space: nowrap;
    }

    .insert-stop-button:hover{
        filter: brightness(0.95);
        transition-duration: .25s;
    }

    .insert-stop-button:disabled{
        background-color: #b7b7b7;
        cursor: not-allowed;
    }

    .insert-stop-add-button{
        background-color: #32ccfe;
    }

    .insert-stop-chips{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 12px;
    }

    .insert-stop-chip{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        background-color: #eef7ff;
        border: 1px solid #32ccfe;
        border-radius: 999px;
        padding: 5px 8px 5px 12px;
        font-size: 13px;
    }

    .insert-stop-chip-remove{
        border: none;
        background-color: #32ccfe;
        color: #fff;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        line-height: 1;
        font-size: 13px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
    }

    .insert-stop-chip-remove:disabled{
        background-color: #b7b7b7;
        cursor: not-allowed;
    }

    .insert-stop-review-row{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 14px;
        gap: 12px;
        flex-wrap: wrap;
    }

    .insert-stop-count{
        font-size: 13px;
        color: #6a6a6a;
    }

    .insert-preview-shipments{
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 8px;
        max-height: 45vh;
        overflow-y: auto;
    }

    .insert-preview-shipment{
        border: 1px solid #eee;
        border-radius: 10px;
        padding: 10px 12px;
    }

    .insert-preview-shipment-top{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }

    .insert-preview-shipment-id{
        font-weight: bold;
        font-size: 14px;
    }

    .insert-preview-shipment-company{
        font-size: 13px;
        color: #3f3f3f;
        text-align: right;
    }

    .insert-preview-shipment-address{
        font-size: 12px;
        color: #6a6a6a;
        margin-top: 2px;
    }

    .insert-preview-shipment .insert-preview-warning,
    .insert-preview-shipment .insert-preview-error{
        margin-top: 8px;
        font-size: 12px;
    }

    .insert-preview-pickup-address{
        margin-top: 3px;
    }

    .insert-preview-pickup-label{
        font-weight: bold;
        color: #33a15f;
    }

    .insert-stop-toggle-container{
        width: 95%;
        margin: 10px auto 10px auto;
        display: flex;
        justify-content: flex-end;
    }

    .insert-stop-toggle-button{
        background-color: #32ccfe;
        border: none;
        padding: 8px 20px;
        border-radius: 999px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition-duration: .25s;
    }

    .insert-stop-toggle-button:hover{
        filter: brightness(0.95);
        transition-duration: .25s;
    }

    @media screen and (max-width: 700px) {
        .insert-stop-field{
            flex-basis: 100%;
        }

        .insert-stop-action{
            flex: 1 1 100%;
        }

        .insert-stop-button{
            width: 100%;
        }
    }

    .insert-preview-overlay{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.45);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .insert-preview-popup{
        background-color: #fff;
        border-radius: 20px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 25px;
        padding: 20px 24px;
        width: 90%;
        max-width: 520px;
        max-height: 85vh;
        overflow-y: auto;
        text-align: left;
    }

    .insert-preview-header{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .insert-preview-header h2{
        margin: 0;
        font-size: 20px;
    }

    .insert-preview-close{
        background: none;
        border: none;
        font-size: 26px;
        line-height: 1;
        cursor: pointer;
        color: #6a6a6a;
    }

    .insert-preview-warning{
        margin-top: 12px;
        padding: 10px 14px;
        background-color: #fff4e5;
        border: 1px solid #fe804d;
        border-radius: 10px;
        font-size: 13px;
        color: #8a4b1f;
    }

    .insert-preview-warning-sheets{
        font-weight: bold;
    }

    .insert-preview-error{
        margin-top: 12px;
        padding: 10px 14px;
        background-color: #fdecea;
        border: 1px solid #e74c3c;
        border-radius: 10px;
        font-size: 13px;
        color: #922b21;
    }

    .insert-preview-activity{
        display: flex;
        flex-direction: column;
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid rgba(231, 76, 60, 0.3);
    }

    .insert-preview-activity-title{
        font-weight: bold;
        margin-bottom: 2px;
    }

    .insert-preview-activity-time{
        font-size: 12px;
        color: #a0524a;
        margin-top: 2px;
    }

    .insert-preview-subtext{
        margin: 14px 0 8px 0;
        font-size: 13px;
        color: #6a6a6a;
    }

    .insert-preview-grid{
        display: flex;
        flex-direction: column;
        border: 1px solid #eee;
        border-radius: 10px;
        overflow: hidden;
    }

    .insert-preview-row{
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 8px 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .insert-preview-row:nth-child(even){
        background-color: #fafafa;
    }

    .insert-preview-row:last-child{
        border-bottom: none;
    }

    .insert-preview-label{
        flex: 0 0 140px;
        font-size: 12px;
        font-weight: bold;
        color: #3f3f3f;
    }

    .insert-preview-value{
        flex: 1 1 auto;
        font-size: 13px;
        color: #000;
        word-break: break-word;
    }

    .insert-preview-input{
        width: 100%;
        max-width: 220px;
        padding: 6px 8px;
        font-size: 13px;
        border: 1px solid rgba(0,0,0,.2);
        border-radius: 8px;
        outline: none;
        background-color: #fff;
        box-sizing: border-box;
        margin: 0;
    }

    .insert-preview-input:focus{
        border-color: #32ccfe;
    }

    .insert-preview-buttons{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 18px;
    }

    .insert-preview-cancel{
        background-color: #e4e4e4;
        border: none;
        padding: 10px 22px;
        border-radius: 999px;
        color: #000;
        font-size: 14px;
        cursor: pointer;
        transition-duration: .25s;
    }

    .insert-preview-cancel:hover{
        filter: brightness(0.95);
    }

    .insert-preview-confirm{
        background-color: #33f18a;
        border: none;
        padding: 10px 22px;
        border-radius: 999px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition-duration: .25s;
    }

    .insert-preview-confirm:hover{
        filter: brightness(0.95);
    }

    .insert-preview-confirm:disabled,
    .insert-preview-cancel:disabled{
        background-color: #b7b7b7;
        color: #fff;
        cursor: not-allowed;
    }
</style>